import { codes as paymentCodes } from 'constants/payment';

export const CARD_TAB_VALUE = 'card';
export const CARD_TAB_LABEL = 'Card';
export const VOUCHER_TAB_VALUE = 'voucher';
export const VOUCHER_TAB_LABEL = 'Voucher';

export const cardTab = {
  value: CARD_TAB_VALUE,
  label: CARD_TAB_LABEL
};
export const voucherTab = {
  value: VOUCHER_TAB_VALUE,
  label: VOUCHER_TAB_LABEL
};

export const refundablePayments = (payments = []) => {
  const prrRefundMethods = [
    paymentCodes.CARD,
    paymentCodes.APPLE_PAY,
    paymentCodes.GOOGLE_PAY,
    paymentCodes.IDEAL,
    paymentCodes.PAYPAL,
    paymentCodes.BUSINESS_ACCOUNT
  ];

  return payments.filter((p) => prrRefundMethods.includes(p.method));
};

export const getDisplayForPayment = (payment) => {
  if (payment.method === paymentCodes.PAYPAL || payment.method === paymentCodes.IDEAL) {
    return `${payment.reference} - ${payment.method}`;
  }

  return `...${payment.externalReference}`;
};
